var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-ideaWrapper"},[_c('section',[_c('iframe',{attrs:{"allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share","allowfullscreen":"","src":"https://www.youtube-nocookie.com/embed/MsuxqZtOXXM?si=yClpJEOL5p0EBsZy","title":"YouTube video player"}})])])
}]

export { render, staticRenderFns }